export default __webpack_public_path__ + "static/media/tote.86e844b7.jpg";